/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import {
    NonceAttestation,
    instanceOfNonceAttestation,
    NonceAttestationFromJSON,
    NonceAttestationFromJSONTyped,
    NonceAttestationToJSON,
} from './NonceAttestation';
import {
    OTPAttestation,
    instanceOfOTPAttestation,
    OTPAttestationFromJSON,
    OTPAttestationFromJSONTyped,
    OTPAttestationToJSON,
} from './OTPAttestation';
import {
    PasswordResetAttestation,
    instanceOfPasswordResetAttestation,
    PasswordResetAttestationFromJSON,
    PasswordResetAttestationFromJSONTyped,
    PasswordResetAttestationToJSON,
} from './PasswordResetAttestation';
import {
    PasswordSetAttestation,
    instanceOfPasswordSetAttestation,
    PasswordSetAttestationFromJSON,
    PasswordSetAttestationFromJSONTyped,
    PasswordSetAttestationToJSON,
} from './PasswordSetAttestation';
import {
    PasswordVerifyAttestation,
    instanceOfPasswordVerifyAttestation,
    PasswordVerifyAttestationFromJSON,
    PasswordVerifyAttestationFromJSONTyped,
    PasswordVerifyAttestationToJSON,
} from './PasswordVerifyAttestation';
import {
    TOTPRegisterAttestation,
    instanceOfTOTPRegisterAttestation,
    TOTPRegisterAttestationFromJSON,
    TOTPRegisterAttestationFromJSONTyped,
    TOTPRegisterAttestationToJSON,
} from './TOTPRegisterAttestation';
import {
    TOTPVerifyAttestation,
    instanceOfTOTPVerifyAttestation,
    TOTPVerifyAttestationFromJSON,
    TOTPVerifyAttestationFromJSONTyped,
    TOTPVerifyAttestationToJSON,
} from './TOTPVerifyAttestation';
import {
    WebAuthnCreateAttestation,
    instanceOfWebAuthnCreateAttestation,
    WebAuthnCreateAttestationFromJSON,
    WebAuthnCreateAttestationFromJSONTyped,
    WebAuthnCreateAttestationToJSON,
} from './WebAuthnCreateAttestation';
import {
    WebAuthnGetAttestation,
    instanceOfWebAuthnGetAttestation,
    WebAuthnGetAttestationFromJSON,
    WebAuthnGetAttestationFromJSONTyped,
    WebAuthnGetAttestationToJSON,
} from './WebAuthnGetAttestation';

/**
 * @type Attestation
 * 
 * @export
 */
export type Attestation = { challenge_type: 'nonce' } & NonceAttestation | { challenge_type: 'otp' } & OTPAttestation | { challenge_type: 'password_reset' } & PasswordResetAttestation | { challenge_type: 'password_set' } & PasswordSetAttestation | { challenge_type: 'password_verify' } & PasswordVerifyAttestation | { challenge_type: 'totp_register' } & TOTPRegisterAttestation | { challenge_type: 'totp_verify' } & TOTPVerifyAttestation | { challenge_type: 'webauthn_create' } & WebAuthnCreateAttestation | { challenge_type: 'webauthn_get' } & WebAuthnGetAttestation;

export function AttestationFromJSON(json: any): Attestation {
    return AttestationFromJSONTyped(json, false);
}

export function AttestationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Attestation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['challenge_type']) {
        case 'nonce':
            return {...NonceAttestationFromJSONTyped(json, true), challenge_type: 'nonce'};
        case 'otp':
            return {...OTPAttestationFromJSONTyped(json, true), challenge_type: 'otp'};
        case 'password_reset':
            return {...PasswordResetAttestationFromJSONTyped(json, true), challenge_type: 'password_reset'};
        case 'password_set':
            return {...PasswordSetAttestationFromJSONTyped(json, true), challenge_type: 'password_set'};
        case 'password_verify':
            return {...PasswordVerifyAttestationFromJSONTyped(json, true), challenge_type: 'password_verify'};
        case 'totp_register':
            return {...TOTPRegisterAttestationFromJSONTyped(json, true), challenge_type: 'totp_register'};
        case 'totp_verify':
            return {...TOTPVerifyAttestationFromJSONTyped(json, true), challenge_type: 'totp_verify'};
        case 'webauthn_create':
            return {...WebAuthnCreateAttestationFromJSONTyped(json, true), challenge_type: 'webauthn_create'};
        case 'webauthn_get':
            return {...WebAuthnGetAttestationFromJSONTyped(json, true), challenge_type: 'webauthn_get'};
        default:
            throw new Error(`No variant of Attestation exists with 'challenge_type=${json['challenge_type']}'`);
    }
}

export function AttestationToJSON(value?: Attestation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['challenge_type']) {
        case 'nonce':
            return NonceAttestationToJSON(value);
        case 'otp':
            return OTPAttestationToJSON(value);
        case 'password_reset':
            return PasswordResetAttestationToJSON(value);
        case 'password_set':
            return PasswordSetAttestationToJSON(value);
        case 'password_verify':
            return PasswordVerifyAttestationToJSON(value);
        case 'totp_register':
            return TOTPRegisterAttestationToJSON(value);
        case 'totp_verify':
            return TOTPVerifyAttestationToJSON(value);
        case 'webauthn_create':
            return WebAuthnCreateAttestationToJSON(value);
        case 'webauthn_get':
            return WebAuthnGetAttestationToJSON(value);
        default:
            throw new Error(`No variant of Attestation exists with 'challenge_type=${value['challenge_type']}'`);
    }

}

